import { all, call, delay, fork, put, takeLatest } from "redux-saga/effects";
import * as Inventory from "../actions/inventoryAction";
import { SAGA_DELAY_TIMEOUT } from "../constants/Define";
import * as Types from "../constants/Types";
import * as Func from "../helpers/functions";
import { parseTourListRequestParams } from "../utils/commonUtils";
import * as TourService from "./../services/tourService";
import * as WarehouseService from "./../services/warehouseService";

// NEW INVENTORY PROCESSES
function* getListInventory() {
  yield takeLatest(
    Types.INVENTORY_GET_LIST_ACTION,
    Func.sagaWrapper(function* (action) {
      const params = parseTourListRequestParams(action.params || {});
      yield delay(SAGA_DELAY_TIMEOUT);
      const result = yield call(WarehouseService.getListGoodReceipt, params);
      yield put(Inventory.setListInventory({ ...result, params }));
    }, errorHandleInventory(Types.INVENTORY_GET_LIST_FAIL))
  );
}

function* getInventoryDetail() {
  yield takeLatest(
    Types.INVENTORY_DETAIL_ACTION,
    Func.sagaWrapper(function* (action) {
      const { id, callbacks } = action;
      const result = yield call(WarehouseService.getWareHouseDetail, id);
      callbacks && callbacks.onSuccess(result);

      yield put(Inventory.setInventoryDetail(result));
    }, errorHandleInventory(Types.INVENTORY_DETAIL_FAIL))
  );
}

function errorHandleInventory(errorActionType) {
  return Func.sagaErrorHandler(function* (e) {
    yield put({ type: errorActionType });
  }, "inventory");
}

export function* inventorySaga() {
  yield all([
    //NEW TOUR PROCESSES
    fork(getListInventory),
    fork(getInventoryDetail),
  ]);
}
